import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const AnalyticsCard = () => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6">Sales Analytics</Typography>
        <Typography variant="body2">
          - Revenue: $32,000<br />
          - Avg. Order: $56<br />
          - Conversion: 3.5%
        </Typography>
      </CardContent>
    </Card>
  );
};

export default AnalyticsCard;